// removed by extract-text-webpack-plugin
module.exports = {"menu-container":"menu__menu-container__Poizu","mask":"menu__mask__fyfzX","menu-wrapper":"menu__menu-wrapper__3m6OO","avatar-container":"menu__avatar-container__3B_HK","avatar":"menu__avatar__3KMCx","list-container":"menu__list-container__1qpRZ","list-item":"menu__list-item__3TNMO","button-wrapper":"menu__button-wrapper__MLlLM","button-inner":"menu__button-inner__3i6fN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/HeaderBar/Menu/menu.scss
// module id = 1726
// module chunks = 1